import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { FilterTextInput } from "./FitlerTextInput";
import { DataType, DataTypeOperator } from "../../../models/audience/filter.model";
import { FilterBooleanInput } from "./FilterBooleanInput";
import { FilterNumericInput } from "./FilterNumericInput";
import { FilterEnumInput } from "./FilterEnumInput";
import { FilterDateInput } from "./filterDateInputUtils";
import { FilterAudienceIdInput } from "./FilterAudienceIdInput";
import { FilterMailingIdInput } from "./FilterMailingIdInput";
var GenericValueInput = function (props) {
    var _a, _b;
    var _c = useTranslation(), t = _c.t, i18n = _c.i18n;
    var operator = props.filterRow.operator;
    // Step 2.9: audience-reference operators are field-independent — they ignore dataType
    // and render a multi-select of saved audiences. The picker stores audience ids in
    // `filterRow.textValues`; the backend resolver inlines each referenced audience's
    // compiled compound.
    if (operator === DataTypeOperator.IN_AUDIENCE || operator === DataTypeOperator.NOT_IN_AUDIENCE) {
        return (_jsx(FilterAudienceIdInput, { filterRow: props.filterRow, setFilterRow: props.setFilterRow }));
    }
    // Step 3d: mailing-engagement operators are field-independent — they render a campaign
    // multi-select (storing campaign ids in textValues), plus an N-days input for
    // RECEIVED_CAMPAIGN_IN_LAST. The backend reads the smartData.mailingHistory rollup.
    if (operator === DataTypeOperator.OPENED_CAMPAIGN
        || operator === DataTypeOperator.CLICKED_CAMPAIGN
        || operator === DataTypeOperator.RECEIVED_CAMPAIGN_IN_LAST) {
        return (_jsx(FilterMailingIdInput, { filterRow: props.filterRow, setFilterRow: props.setFilterRow }));
    }
    var getEnumLocalized = function (enumValue) {
        if (i18n.exists("Filter_enum_".concat(enumValue))) {
            return t("Filter_enum_".concat(enumValue));
        }
        else {
            return enumValue || '(empty value)';
        }
    };
    var result = null;
    var operatorOverride = operator;
    var dataType = props.dataType;
    if ((dataType == DataType.LOCAL_DATE || dataType == DataType.TIMESTAMP) && operator == DataTypeOperator.LAST) {
        dataType = DataType.NUMBER;
        operatorOverride = DataTypeOperator.EQUAL;
    }
    // Step 3.0 — relative-day windows around today take two integer offsets stored in
    // longValues. Render via the numeric BETWEEN input (two number fields), regardless of
    // the underlying field's date type.
    if ((dataType == DataType.LOCAL_DATE || dataType == DataType.TIMESTAMP)
        && (operator == DataTypeOperator.RELATIVE_DAYS_FROM_TODAY
            || operator == DataTypeOperator.RELATIVE_DAYS_NOT_FROM_TODAY)) {
        dataType = DataType.NUMBER;
        operatorOverride = DataTypeOperator.BETWEEN;
    }
    switch (dataType) {
        case DataType.NUMBER:
            result = (_jsx(FilterNumericInput, { operator: operatorOverride, filterRow: props.filterRow, setFilterRow: props.setFilterRow, type: 'int' }));
            break;
        case DataType.DECIMAL:
            result = (_jsx(FilterNumericInput, { operator: operator, filterRow: props.filterRow, setFilterRow: props.setFilterRow, type: 'decimal' }));
            break;
        case DataType.TEXT:
            result = (_jsx(FilterTextInput, { operator: operator, filterRow: props.filterRow, setFilterRow: props.setFilterRow, idType: (_a = props.option) === null || _a === void 0 ? void 0 : _a.idType, forceSectorId: props.forceSectorId }));
            break;
        case DataType.TIMESTAMP:
            result = (_jsx(FilterDateInput, { operator: operator, filterRow: props.filterRow, setFilterRow: props.setFilterRow, type: 'timestamp' }));
            break;
        case DataType.LOCAL_DATE:
            result = (_jsx(FilterDateInput, { operator: operator, filterRow: props.filterRow, setFilterRow: props.setFilterRow, type: 'localDate' }));
            break;
        case DataType.ENUM:
            result = (_jsx(FilterEnumInput, { operator: operator, filterRow: props.filterRow, setFilterRow: props.setFilterRow, enumValues: ((_b = props.option) === null || _b === void 0 ? void 0 : _b.enumValues) || [] }));
            break;
        case DataType.BOOL:
            switch (operator) {
                case DataTypeOperator.TRUE:
                case DataTypeOperator.FALSE:
                    return null;
            }
            result = _jsx(FilterBooleanInput, { operator: operator, filterRow: props.filterRow, setFilterRow: props.setFilterRow });
            break;
    }
    return result;
};
export default GenericValueInput;
